interface BadgeProps {
	type: 'green' | 'gray';
	text: string;
}

export const Badge = ({ type, text }: BadgeProps) => {
	return (
		<span
			className={`inline-flex items-center gap-2 rounded-md border px-3 py-1 text-xs font-medium ${
				type === 'green' ? 'border-green-200 bg-green-50 text-green-700' : 'border-gray-200 bg-gray-50 text-gray-700'
			}`}
		>
			<span className={`size-2 rounded-md ${type === 'green' ? 'bg-green-500' : 'bg-gray-500'}`}></span>
			{text}
		</span>
	);
};
